package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ChatExpertModeModel(
    @SerialName("total_steps_count")
    val totalStepsCount: Int,
    @SerialName("total_time_spent_sec")
    val totalTimeSpentSec: Double,
    val steps: List<ChatExpertModeStepModel>
)